export default __webpack_public_path__ + "static/media/house_1.c51150e8.png";